export default {
    data: function () {
        return {
            showForm: false,
            edit: null,

        }
    },
    methods: {
        itemSelected(item) {
            this.edit = item.id;
            this.showForm = true;
        },
        newItemClick() {
            this.edit = null;
            this.showForm = true;
        },
        backToPageClick: function () {
            this.edit = null;
            this.showForm = false;
            this.getStateTotal()
        },
        itemCreated(id) {
            this.edit = id;
            this.$refs.datalist.updateList()
        },
        itemUpdated: function (id) {
            this.$refs.datalist.updateList()
        },
        itemDeleted: function (id) {
            this.edit = null;
            this.showForm = false;
            this.$refs.datalist.updateList();
            this.getStateTotal()

        },
        getStateTotal() {
            this.axios
                .get(this.totalLink)
                .then(({data}) => {
                    this.total = data.data;
                });
        }
    },
    mounted() {
        this.getStateTotal()
    },
}


// WEBPACK FOOTER //
// ./src/mixins/mixinPage.js